
<SmartblockList
  class="sdv-activation-smartblock-list"
  :context="context"
  :template="template"
  :block-style="blockStyle"
  @analytics="listeners.onAnalytics"
  @action="listeners.onAction"
  @call-event="listeners.onSmartblockEvent"
/>
